import { render, staticRenderFns } from "./QuestionInfoCard.vue?vue&type=template&id=e65d2b6a"
import script from "./QuestionInfoCard.vue?vue&type=script&lang=js"
export * from "./QuestionInfoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports